import React from "react";
import { useVSU } from "../store";
import PieChartCard from "./PieChartCard";

// Три равнозначные круговые диаграммы в одном ряду (RQ.22.02–RQ.22.04).
export default function PieCharts() {
  const { t, breakdowns } = useVSU();
  const b = breakdowns ?? { by_source: [], by_address: [], by_location: [] };

  return (
    <div className="vsu-pies">
      <PieChartCard title={t("cSrc")} field="by_source" data={b.by_source} />
      <PieChartCard title={t("cAddr")} field="by_address" data={b.by_address} />
      <PieChartCard
        title={t("cLoc")}
        field="by_location"
        data={b.by_location}
      />
    </div>
  );
}
